import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'main',
    'form',
    'questions',
    'question',
    'next',
    'prev',
    'skipSlide',
    'skipSlideCareInsuranceBurdenRatio',
    'skipSlideMedicalCareNighttime',
    'stepAddress',
    'addressInput',
    'nameInput',
    'displayedSymptomsOfDementiaSlide',
  ]

  get isOfferInquiry () {
    return this.element.dataset.isofferinquiry
  }

  static values = {
    abCategory: String,
  }

  connect () {
    this.slidePosition = 0
    this.skipQuestionNumber = null
    this.slideWidth = this.mainTarget.clientWidth

    this.questionsTarget.style.width = `${this.questionTargets.length * this.slideWidth}px`
    this.questionsTarget.style.transform = 'translate3d(0px, 0px, 0px)'

    this.questionTargets.forEach((element, index) => {
      if (index === this.slidePosition) {
        element.style.visibility = 'visible'
        element.style.height = 'auto'
      } else {
        element.style.visibility = 'hidden'
        element.style.height = '0'
      }
    })

    if (this.isOfferInquiry === 'false') {
      const spanElement = document.createElement('span')
      this.addressInputTargets.forEach((element) => { element.required = false })
      this.stepAddressTargets.forEach((element) => { element.parentNode.replaceChild(spanElement, element) })
    }
  }

  checkRequired (currentStep) {
    // 画面内の項目の入力チェックを行い、すべて入力されていた場合は「次へ」ボタンを有効にする
    let valid = true
    const inputNames = []
    const requiredInputs = this.questionTargets[currentStep].querySelectorAll('input:required, select:required, textarea:required')

    requiredInputs.forEach(input => {
      if (!inputNames.includes(input.name) && !input.hidden && !input.disabled) {
        inputNames.push(input.name)
      }
    })

    const formData = new FormData(this.formTarget)

    inputNames.forEach(name => {
      if (!formData.get(name)) {
        valid = false
      }
    })

    return valid
  }

  changeValue (e) {
    const currentStep = e.target.dataset.current - 1

    if (this.checkRequired(currentStep)) {
      this.nextTargets[currentStep].disabled = false
    } else {
      this.nextTargets[currentStep].disabled = true
    }
  }

  sendViewEvent (nextEventName) {
    const nextEventNameSplit = nextEventName.split(':')
    nextEventNameSplit.splice(2, 1, 'view')
    const viewEventName = nextEventNameSplit.join(':')

    dataLayer.push({
      event: 'next.slide',
      event_label: viewEventName,
    })
  }

  checkInquiryCategory () {
    const checkedRequestForDocument = document.getElementsByName('inquiry[inquiry_facilities_attributes][0][request_for_document]')[0].checked
    if (!checkedRequestForDocument) {
      const spanElement = document.createElement('span')
      this.addressInputTargets.forEach((element) => { element.required = false })
      this.stepAddressTargets.forEach((element) => { element.parentNode.replaceChild(spanElement, element) })
    }
  }

  clickNext (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      this.slidePosition += 1
      if (this.skipQuestionNumber === this.slidePosition) {
        this.slidePosition += 1
      }
      this.setMovedStyle()
    }
  }

  // TODO: 「リハビリを希望しますか？」の次へボタンで使用中 本番反映の場合イベント名を適切なものに変更
  clickNext2Steps (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      if (this.skipSlideTarget.checked) {
        this.slidePosition += 1
      } else {
        this.slidePosition += 2
      }
      this.setMovedStyle()
    }
  }

  clickNextSkipSlideCareInsuranceBurdenRatio (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      const anyChecked = this.skipSlideCareInsuranceBurdenRatioTargets.some((el) => el.checked)
      if (anyChecked) {
        this.slidePosition += 2
      } else {
        this.slidePosition += 1
      }
      this.setMovedStyle()
    }
  }

  clickNextSkipSlideMedicalCareNighttime (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      const anyChecked = this.skipSlideMedicalCareNighttimeTargets.some((el) => el.checked)
      if (anyChecked) {
        this.slidePosition += 1
      } else {
        this.slidePosition += 2
      }

      this.setMovedStyle()
    }
  }

  clickNextWithCheckRequired (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition < this.questionTargets.length - 1 && this.slidePosition === currentPosition - 1) {
      this.slidePosition += 1
      this.setMovedStyle()
    }

    if (this.checkRequired(currentPosition)) {
      this.nextTargets[currentPosition].disabled = false
    } else {
      this.nextTargets[currentPosition].disabled = true
    }
  }

  clickPrev (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition > 0 && this.slidePosition === currentPosition - 1) {
      this.slidePosition -= 1
      if (this.skipQuestionNumber === this.slidePosition) {
        this.slidePosition -= 1
      }
      this.setMovedStyle()
    }
  }

  // TODO: 「提携外病院への送迎」の戻るボタンで使用中 本番反映の場合イベント名を適切なものに変更
  clickPrev2Steps (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition > 0 && this.slidePosition === currentPosition - 1) {
      if (this.skipSlideTarget.checked) {
        this.slidePosition -= 1
      } else {
        this.slidePosition -= 2
      }
      this.setMovedStyle()
    }
  }

  clickPrevSkipSlideCareInsuranceBurdenRatio (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition > 0 && this.slidePosition === currentPosition - 1) {
      const anyChecked = this.skipSlideCareInsuranceBurdenRatioTargets.some((el) => el.checked)
      if (anyChecked) {
        this.slidePosition -= 2
      } else {
        this.slidePosition -= 1
      }
      this.setMovedStyle()
    }
  }

  clickPrevSkipSlideMedicalCareNighttime (e) {
    e.preventDefault()

    const currentPosition = Number(e.target.dataset.current)

    if (this.slidePosition > 0 && this.slidePosition === currentPosition - 1) {
      const anyChecked = this.skipSlideMedicalCareNighttimeTargets.some((el) => el.checked)
      if (anyChecked) {
        this.slidePosition -= 1
      } else {
        this.slidePosition -= 2
      }
      this.setMovedStyle()
    }
  }

  setMovedStyle () {
    this.questionTargets.forEach((element, index) => {
      if (index === this.slidePosition) {
        element.style.visibility = 'visible'
        element.style.height = 'auto'
      } else {
        element.style.visibility = 'hidden'
        element.style.height = '0'
      }
    })
    this.questionsTarget.style.transform = `translate3d(-${this.slideWidth * this.slidePosition}px, 0px, 0px)`
  }
}
